import {
    STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBranchOfficesDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                locationOptions: [],
                branchOfficeOptions: [],
                branchOfficeOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_SUCCESS:
        const branchOfficeDefaultValue = action.data.branchOfficeDefault || state.takingCarManagement.fastStockLoading.branchOfficeDefault
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBranchOfficesDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                branchOfficeOptions: action.data.branchOfficesList,
                branchOfficeDefault : branchOfficeDefaultValue,
                branchOfficeOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getBranchOfficesDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                branchOfficeOptions: [],
                branchOfficeOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  